import { ENTITIES } from 'src/models/QuerybuilderModel';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import UnselectAllMenubutton from 'src/components/Control/Buttons/UnselectAllMenuButton';
import SelectAllMenubutton from 'src/components/Control/Buttons/SelectAllMenuButton';
import ConfigureColumnsButton from 'src/components/Control/Buttons/ConfigureColumnsButton';
import { FundraisingTransaction } from 'src/models/FundraisingModel';
import ShowInvoiceTransactionButton
  from 'src/components/Control/Buttons/ShowInvoiceTransactionButton';
import ShowPaymentTransactionButton
  from 'src/components/Control/Buttons/ShowPaymentTransactionButton';
import EditTransactionButton from 'src/components/Control/Buttons/EditTransactionButton';
import { useEffect } from 'react';
import { getFundraisingTransactionAction } from 'src/redux/actions/FundraisingTransactionAction';
import DownloadTransactionsButton from 'src/components/Control/Buttons/DownloadTransactionButton';

const FundraisingTransactionsToolbar = () => {
  const dispatch = useAppDispatch();
  const selections = useSelector(
    (state: Store) => state.selected[ENTITIES.fundraisingTransactions] || [],
  );

  const fundraisingTransactions = useSelector(
    (state: Store) => {
      if (selections.length === 0) return {} as FundraisingTransaction;
      if (!state.fundraisingTransaction[selections[0]]) return {} as FundraisingTransaction;
      return state.fundraisingTransaction[selections[0]] as FundraisingTransaction;
    },
  );

  useEffect(() => {
    if (selections[0]) {
      dispatch(getFundraisingTransactionAction(selections[0]));
    }
  }, [selections]);

  const paymentId = fundraisingTransactions?.payment_id || 0;
  const invoiceId = fundraisingTransactions?.invoice_id || 0;

  return (

    <>
      <EditTransactionButton />
      <DownloadTransactionsButton />
      <ShowPaymentTransactionButton paymentId={paymentId} />
      <ShowInvoiceTransactionButton invoiceId={invoiceId} />
      <ConfigureColumnsButton
        entity={ENTITIES.fundraisingTransactions} />
      <UnselectAllMenubutton
        entity={ENTITIES.fundraisingTransactions}
        disabled={!selections.length} />
      <SelectAllMenubutton
        entity={ENTITIES.fundraisingTransactions} />
    </>
  );
};
export default FundraisingTransactionsToolbar;
